export default __webpack_public_path__ + "static/propertybanner-desktop-d379ab410c4ae94ad63c6130b04d70b4.jpg";